<div class="sub-footer !h-[50px]">
  <div class="container">
    <nav>
      <h3>{{ getMenuLabelStartingFromCaptive() }}</h3>
      <ul>
        <li *ngFor="let linkEl of subFooterLinks">
          <span class="link font-small" (click)="openLink(linkEl.link)">
            {{ linkEl.description | i18n }}
          </span>
        </li>
      </ul>
    </nav>
    <div *ngIf="disableIfNotMyAld()" class="copy">
      &copy; {{ year }} ALD Automotive Italia a socio unico
    </div>
    <div class="cookie font-regular">
      <span class="cookieSpan">Cookie Policy</span>
      <a href="javascript:Didomi.preferences.show()">
        <i class="fa-solid fa-gear"></i>
      </a>
    </div>
  </div>
</div>
